import { render } from "./KRActivityPanel.vue?vue&type=template&id=b55b6e10"
import script from "./KRActivityPanel.vue?vue&type=script&lang=js"
export * from "./KRActivityPanel.vue?vue&type=script&lang=js"
script.render = render

export default script